module.exports = __webpack_public_path__ + "img/clients3-1023.ef62c79.png";